<script src="https://js.stripe.com/v3/"></script>
<div class="api-container">
  <button type="button" class="back-link" (click)="goBack()">
    <img class="back-icon" src="assets/images/back-icon.svg" alt="" aria-hidden="true">
    <span>Back</span>
  </button>

  <div class="hero-copy">
    <h1 class="title">— API Upgrade Subscription —</h1>
    <p class="subtitle">Choose your new subscription plan</p>
    <p class="description">
      *** Explanation about how the upgrade subscription works with the different costs and dates ***
    </p>
  </div>

  <div class="subscription-card">
    <div class="section-block">
      <h2 class="section-title">Choose your API package</h2>

      <div
        class="plan-row"
        *ngFor="let plan of plans"
      >
        <div
          class="plan"
          [class.active]="isActive(plan)"
          [class.disabled]="isDisabled(plan) || loading"
          (click)="!loading && !isDisabled(plan) && selectPlan(plan)"
        >
          <div class="radio">
            <span *ngIf="isRadioActive(plan)"></span>
          </div>

          <div class="plan-info">
            <strong class="plan-calls">{{ plan.calls }} API Calls per month</strong>
            <span class="price">{{ plan.price }}</span>
          </div>
        </div>

        <div *ngIf="isCurrent(plan)" class="badge current-badge">
          Current plan
        </div>

        <div
          *ngIf="!isCurrent(plan) && selectedPlan?.id === plan.id"
          class="badge new-badge"
        >
          New plan
        </div>
      </div>
    </div>
  </div>

  <div class="payment-card">
    <div class="payment-panel">
      <div class="payment-box">
        <div class="payment-method selected">
          <h3 class="section-title payment-title">Choose the payment method</h3>

          <div class="btn_compras" [style.height]="loading ? '70px' : 'auto'">
            <div
              class="row stripe-box"
              [class.disabled]="loading || checkoutInitialized"
              (click)="!loading && !checkoutInitialized && iniciarPagoStripe()"
            >
              <div class="stripe-label-wrap">
                Stripe
                <div class="div_loader_pag_stripe" *ngIf="loading">
                  <div class="loader_pag"></div>
                </div>
              </div>
              <img class="img_stripe" src="assets/images/stripe-logo.svg" alt="Stripe">
            </div>

            <div class="details_pay_stripe" *ngIf="showError">
              {{ errorMessage }}
            </div>

            <div id="checkout"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
